import { Button, Form, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { useState } from "react";
import { Video } from "../../interfaces/Video";
import { useNavigate } from "react-router-dom";
import Uploader from "../../elements/Uploader";
import { Media } from "../../interfaces/Media";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";
import { handleApiError, safeJsonParse } from "../../../utils/api";

export interface VideoEditProps {
    video: Video;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function VideoEdit(props: VideoEditProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();

    const [media, setMedia] = useState<Media[]>(props.video.media);

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        let error = false;
        let error_messages: string[] = [];
        if (error) {
            alert(error_messages.join('\n'));
        } else {
            const newVideo = Object.assign({}, props.video);
            newVideo.title = event.target.title.value;
            newVideo.description = event.target.description.value;
            newVideo.media = media.map((m: Media) => { return m; });
            newVideo.updated = new Date();
            const requestOptionsPost = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newVideo)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/video-tutorials/' + props.video._id, requestOptionsPost)
                .then(response => {
                    if (handleApiError(response, navigate)) {
                        return null;
                    }
                    return safeJsonParse(response);
                })
                .then(data => {
                    if (!data) return;
                    props.submitCallback(newVideo);
                });
        }
    }

    const handleMediaUpload = (media: Media[]) => {
        const newMedia: Media[] = [];
        if (media.length > 0) {
            newMedia.push(media.slice(-1)[0])
            const hasVideos = newMedia.filter((m: Media) => m.mimetype == 'video/mp4').length > 0;
            if (!hasVideos) {
                alert(t("Only MP4 videos are allowed."));
                return;
            }
            setMedia(newMedia);
        } else {
            setMedia([]);
        }
    }

    return(
        <Overlay title={t("Edit Video")} onClose={handleClose} className="admin-edit-video-container">
            <div className="video-item-form-container">
                <Form onSubmit={ handleSubmit }>
                    <FormGroup className="title" controlId="title">
                        <Form.Label aria-required={ true }>{ t("Title") }</Form.Label>
                        <Form.Control type="text" required={ true } defaultValue={ props.video.title }
                            placeholder={ t("Enter a title") } />
                    </FormGroup>
                    <Form.Group className="field field-description">
                        <FormLabel htmlFor="description">{ t("Description") }</FormLabel>
                        <FormControl as="textarea" defaultValue={ props.video.description } name="description" />
                    </Form.Group>
                    <Uploader media={ media } save={ handleMediaUpload } />
                    <div className="actions">
                        <Button type="submit" variant="primary">{ t("Save") }</Button>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}